module.exports = __webpack_public_path__ + "media/images/common/img_avatar-3409d54172ec1919dfc520ac7eb7eb6d.png";